import { ChartDonut, STATUSPAGE } from '@repo/ui';

interface ChartStudentsWithAndWithoutAppProps {
  studentsWithAndApp: {
    studentsWithApp: number;
    studentsWithoutApp: number;
  };
  loading: STATUSPAGE;
  legendItems: {
    label: string;
    colorClass: string;
    icon: string;
  }[];
  colorsCartDonut: string[];
  titleChartDonut: string;
  labelsCartDonut: string[];
}

export const ChartStudentsWithAndWithoutApp = ({
  loading,
  legendItems,
  labelsCartDonut,
  colorsCartDonut,
  titleChartDonut,
  studentsWithAndApp,
}: ChartStudentsWithAndWithoutAppProps) => {
  return (
    <ChartDonut
      loading={loading}
      chartData={[
        studentsWithAndApp?.studentsWithApp,
        studentsWithAndApp?.studentsWithoutApp,
      ]}
      legendItems={legendItems || []}
      colors={colorsCartDonut || []}
      title={titleChartDonut}
      labels={labelsCartDonut || []}
    />
  );
};
